import {Stack} from '@mui/material'

import React, {ReactNode} from 'react'

import {InnerWrapper, Label, OuterWrapper, StyledText} from './style'

export interface TextWithLabelProps {
  text: string
  label: string
  width?: number
  icon: ReactNode
}

/**
 * Text with Label component for read-only texts
 */
export function TextWithLabel(props: TextWithLabelProps) {
  const {text, label, width, icon} = props

  return (
    <OuterWrapper style={{width}}>
      <Label>{label}</Label>
      <InnerWrapper>
        <Stack>
          {text?.split('\n').map((item, index) => (
            <StyledText key={`${item}-${index}`} variant="body1">
              {item}
            </StyledText>
          ))}
        </Stack>
        {icon}
      </InnerWrapper>
    </OuterWrapper>
  )
}
